// extracted by mini-css-extract-plugin
module.exports = {"wrapperBody":"ModalDocumentScan_wrapperBody__2b2hp","wrapperTitle":"ModalDocumentScan_wrapperTitle__1Wwx1"};